module.exports = __webpack_public_path__ + "img/Grupo 1598@2x.4210315f.png";